import React, { Component } from "react";
//estilos de material design
import {
  Container,
  Paper,
  Grid,
  Breadcrumbs,
  Link,
  Typography,
  TextField,
  Card,
  CardMedia,
  CardContent,
  CardActions,
  Button,
  ButtonGroup
} from "@material-ui/core";
import HomeIcon from "@material-ui/icons/Home";
import ArrowLeft from "@material-ui/icons/ArrowLeft";
import ArrowRight from "@material-ui/icons/ArrowRight";
//objeto firebase
import { consumerFirebase } from "../../server";
//imagen por defecto si no hay foto de inmueble
import logo from "../../logo.svg";
//funcionalidad de la paginacion
import { getDataNext, getDataBefore } from "../../session/actions/EstateAction";

const style = {
  cardGrid: {
    paddingTop: 8,
    paddingBottom: 8
  },
  paper: {
    backgroundColor: "#f5f5f5",
    padding: "20px",
    marginTop: "20px",
    minHeight: 650
  },
  link: {
    display: "flex"
  },
  gridTextfield: {
    marginTop: "20px"
  },
  card: {
    height: "100%",
    display: "flex",
    flexDirection: "column"
  },
  cardMedia: {
    paddingTop: "56.25%"
  },
  cardContent: {
    flexGrow: 1
  },
  barButton: {
    marginTop: "20px"
  },
  buttonArrows: {
    marginTop: "20px"
  }
};

class EstateList extends Component {
  //estado del componente
  state = {
    estates: [],
    searchText: "",
    //paginacion
    pages: [],
    pageSize: 9,
    initEstate: null,
    actuallyPage: 0
  };
  //capturar el texto introducido en la input de busqueda con el name y el value
  changeSearchText = e => {
    // this.setState({
    //   [e.target.name] : e.target.value
    // });
    const self = this;
    //se realiza para que haya cierto timeout antes de realizar la accion de busqueda
    self.setState({
      [e.target.name]: e.target.value
    });
    //comprobar que existe dentro del state un valor que contenga el typingTimeout si exite que lo limpie
    if (self.state.typingTimeout) {
      clearTimeout(self.state.typingTimeout);
    }
    //Y sino espere a que el usuario termine de escribir en la caja de texto y que realice la busqueda
    self.setState({
      name: e.target.value,
      typing: false,
      typingTimeout: setTimeout(goTime => {
        //cambiamos este codigo para introducir la paginacion
        const firebase = this.props.firebase;
        const { pageSize, actuallyPage} = this.state;
        getDataBefore(firebase, pageSize,actuallyPage, self.state.searchText).then(
          firebaseReturnData => {
            // Json pagina inicial
            const page = {
              initialData: firebaseReturnData.initialData,
              finallyData: firebaseReturnData.finallyData
            };
            // vaciamos el array de paginas - se reinicializa el array de paginas - si utilizamos el array pages[] del estado daria un error por ser una constante y no poder cambiar sus valores - y la pagina inicial a 0
            const pages = [];
            // llenamos el array de paginas
            pages.push(page);
            // modificamos el estado
            this.setState({
              actuallyPage: 0,
              pages,
              estates: firebaseReturnData.arrayEstates
            });
          }
        );

        /*preparacion de la consulta a la BBDD
        let objectQuery = this.props.firebase.db
          .collection("Estates")
          .orderBy("direction")
          .where(
            "keywords",
            "array-contains",
            self.state.searchText.toLowerCase()
          );
        //cuando la caja de búsqueda este vacia muestra todos los inmuebles
        if (self.state.searchText.trim() === "") {
          objectQuery = this.props.firebase.db
            .collection("Estates")
            .orderBy("direction");
        }
        //ejecucion de la consulta a la BBDD
        objectQuery.get().then(snapShot => {
          const arrayEstate = snapShot.docs.map(doc => {
            let data = doc.data();
            let id = doc.id;
            return { id, ...data };
          });
          this.setState({
            estates: arrayEstate
          });
        });*/

      }, 500)
    });
  };
  //metodo para pagina anterior
  beforePage = () => {
    const { searchText, pages, pageSize,  actuallyPage } = this.state;

    if (actuallyPage > 0) {
      const firebase = this.props.firebase;
      getDataBefore(
        firebase,
        pageSize,
        pages[actuallyPage - 1].initialData,
        searchText
      ).then(firebaseReturnData => {
        // Json pagina inicial
        const page = {
          initialData: firebaseReturnData.initialData,
          finallyData: firebaseReturnData.finallyData
        };
        // llenamos el array de paginas
        pages.push(page);
        // modificamos el estado
        this.setState({
          pages,
          actuallyPage: actuallyPage - 1,
          estates: firebaseReturnData.arrayEstates
        });
      });
    }
  };

  // metodo para pagina siguiente
  nextPage = () => {
    const {
      searchText,
      pages,
      pageSize,
      actuallyPage
      //initialEstate
    } = this.state;
    const firebase = this.props.firebase;
    //llamamos al metodo get data en : ../../session/actions/EstateAction
    getDataNext(
      firebase,
      pageSize,
      pages[actuallyPage].finallyData, //initEstate
      searchText
    ).then(firebaseReturnData => {
      if (firebaseReturnData.arrayEstates.length > 0) {
        // Json pagina inicial
        const page = {
          initialData: firebaseReturnData.initialData,
          finallyData: firebaseReturnData.finallyData
        };
        // llenamos el array de paginas
        pages.push(page);
        // modificamos el estado
        this.setState({
          pages,
          actuallyPage: actuallyPage + 1,
          estates: firebaseReturnData.arrayEstates
        });
      }
    });
  };

  //llamada a la bbdd para traer la lista de inmuebles cuando el componente este montado
  async componentDidMount() {
    //al incluir la paginacion se elimina el código comentado abajo
    const { searchText, pages, pageSize, initEstate } = this.state;
    const firebase = this.props.firebase;
    // lo que retorma la funcion getDataNext() lo almacenamos en la variable firebaseReturnData
    // devuelve un json que contiene el arreglo de inmuebles, el valor inicial y final de este arreglo
    const firebaseReturnData = await getDataBefore(
      firebase,
      pageSize,
      initEstate,
      searchText
    );

    // creamos un objeto json de tipo pagina con los valores retornados de la funcion getDataNext()
    const page = {
      initialData: firebaseReturnData.initialData,
      finallyData: firebaseReturnData.finallyData
    };
    // llenamos el array de paginas
    pages.push(page);
    // modificamos el estado
    this.setState({
      estates: firebaseReturnData.arrayEstates,
      pages,
      actuallyPage: 0
    });

    /*consulta a la bbdd de los inmuebles
    let objectQuery = this.props.firebase.db
      .collection("Estates")
      .orderBy("direction");
    //realizamos la consulta
    const snapShot = await objectQuery.get();
    //incluye el id del estate ya que este no viene por defecto
    const arrayEstate = snapShot.docs.map(doc => {
      let data = doc.data();
      let id = doc.id;
      return { id, ...data };
    });
    //cambiamos el estado del componente
    this.setState({
      estates: arrayEstate
    });*/
  }

  //eliminar un inmueble de la bbdd
  deleteEstate = id => {
    this.props.firebase.db
      .collection("Estates")
      .doc(id)
      .delete()
      .then(success => {
        this.deleteEstateFromListEstates(id);
      });
  };
  //elimina el inmueble borrado de la bbdd de la vista lista de inmuebles
  deleteEstateFromListEstates = id => {
    const newListEstates = this.state.estates.filter(
      estate => estate.id !== id
    );
    this.setState({
      estates: newListEstates
    });
  };

  //funcion para editar inmueble
  editEstate = id => {
    this.props.history.push("/estate/" + id);
  };

  render() {
    return (
      <Container style={style.cardGrid}>
        <Paper style={style.paper}>
          <Grid item xs={12} sm={12}>
            <Breadcrumbs aria-label="breadcrubs">
              <Link color="inherit" style={style.link} href="/">
                <HomeIcon />
                Home
              </Link>
              <Typography color="textPrimary"> My estates</Typography>
            </Breadcrumbs>
          </Grid>

          <Grid item xs={12} sm={6} style={style.gridTextfield}>
            <TextField
              fullWidth
              InputLabelProps={{
                shrink: true
              }}
              name="searchText"
              variant="outlined"
              label="enter the property to search"
              value={this.state.searchText}
              onChange={this.changeSearchText}
              placeholder="Introduce ciudad para realizar la búsqueda"
            />
          </Grid>

          <Grid item xs={12} sm={12} style={style.buttonArrows}>
            <Grid
              container
              spacing={1}
              direction="column"
              alignItems="flex-end"
            >
              <ButtonGroup size="small" aria-label="Small outlined group">
                <Button onClick={this.beforePage}>
                  <ArrowLeft />
                </Button>
                <Button onClick={this.nextPage}>
                  <ArrowRight />
                </Button>
              </ButtonGroup>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={12} style={style.gridTextfield}>
            <Grid container spacing={4}>
              {this.state.estates.map(card => (
                <Grid item key={card.id} xs={12} sm={6} md={4}>
                  <Card style={style.card}>
                    <CardMedia
                      style={style.cardMedia}
                      // imagenes vienen del campo estates.photos del componente NewState
                      image={
                        card.photos
                          ? card.photos[0] //si el primer elemento no tiene valor va a dar error entonces:
                            ? card.photos[0] //se realiza una nueva comprobacion para que imprima el logo
                            : logo
                          : logo
                      }
                      title="Estates"
                    />
                    <CardContent style={style.cardContent}>
                      <Typography gutterBottom variant="h6" component="h2">
                        {card.city + ", " + card.country}
                      </Typography>
                    </CardContent>

                    <CardActions>
                      <Button
                        size="small"
                        color="primary"
                        onClick={() => this.editEstate(card.id)}
                      >
                        Edit
                      </Button>
                      <Button
                        size="small"
                        color="primary"
                        onClick={() => this.deleteEstate(card.id)}
                      >
                        Delete
                      </Button>
                    </CardActions>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Paper>
      </Container>
    );
  }
}

export default consumerFirebase(EstateList);
